import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './index.css';

/**
 * One cache for the app.
 *
 * `retry: false` on mutations, always: every mutating route here either moves money or moves a
 * record through a workflow, and a silent retry of a refused transition is how a double
 * settlement happens. The routes that *are* safe to retry carry an `Idempotency-Key`, which
 * makes the retry a replay rather than a second act.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: { retry: false },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
